import { Typography } from '@mui/material';
import { Variant } from '@mui/material/styles/createTypography';
import React, { FC } from 'react';
import { formatMoney } from 'utils/helpers';

export type TextProps = {
  value: string | number,
  variant?: Variant,
  isMoney?: boolean,
  leftAdorment?: string | React.ReactNode,
  fontWeight?: 'bold' | 'normal' | '500',
  color?: | 'initial'
  | 'inherit'
  | 'primary'
  | 'secondary'
  | 'textPrimary'
  | 'textSecondary'
  | 'error',
  style?: React.CSSProperties,
  maxLength?: number
  decimals?: number
}

export const Text: FC<TextProps> = ({
  value,
  variant = 'body2',
  isMoney = false,
  leftAdorment = null,
  fontWeight = 'normal',
  color = 'textPrimary',
  style = {},
  maxLength,
  decimals
}) => {
  let text = value?.toString() ?? '';
  if (isMoney && !Number.isNaN(Number(text))) {
    text = formatMoney(Number(value), decimals);
  }

  if (maxLength && text.length > maxLength) {
    text = `${text.toString().substring(0, maxLength - 3)}...`;
  }

  return (
    <Typography
      variant={variant}
      color={color}
      style={{ ...style, fontWeight }}
    >
      {leftAdorment}
      {text}
    </Typography>
  );
};
